<template>
    <div>
        <rkm-area
            title="Problemas e/ou condições - EMAD"
            type="box"
            background-color="primary"
            closed
        >
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-checkbox-group
                        name="Condição avaliada"
                        v-model="data.model.condicoesEmad"
                    >
                        <rkm-form-checkbox
                            v-for="condicao in data.form.problemaCondicao.condicoesEmad"
                            :key="condicao.codigo"
                            :value="condicao.codigo"
                            class="w-50 m-0"
                        >
                            {{ condicao.nome }}
                        </rkm-form-checkbox>
                    </rkm-form-checkbox-group>
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </div>
</template>

<script>
export default {
    props: {
        data: {type: Object, required: true},
        readonly: {type: Boolean, default: false},
    },
}
</script>